import Tooltip from 'rc-tooltip';
import React from 'react';
import { Paper } from './Paper';
import { Global } from './Popover.styles';
import { popoverProps } from './Popover.props';
import './popover.theme';

export const Popover = ({ paperProps, overlay, ...rest }) => (
  <>
    <Global id="global-popover-styles" />
    <Tooltip
      {...rest}
      overlay={
        <Paper padded rounded {...paperProps}>
          {overlay}
        </Paper>
      }
    />
  </>
);

Popover.props = popoverProps;
Popover.defaultProps = {
  animation: 'zoom',
};
